module.exports = __webpack_public_path__ + "images/variant-separation-1af94a2c.svg";